import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { EventInfoItem } from "@/features/study-group-events/utils/eventInfo";

interface EventInfoDialogProps {
  open: boolean;
  items: EventInfoItem[];
  onOpenChange: (open: boolean) => void;
  onCopy: (
    value: string | undefined | null,
    label: string,
  ) => Promise<void> | void;
}

export const EventInfoDialog = ({
  open,
  items,
  onOpenChange,
  onCopy,
}: EventInfoDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {t("eventManage.reminderEmailEventInfoTitle")}
          </DialogTitle>
          <DialogDescription>
            {t("eventManage.reminderEmailEventInfoDescription")}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {items.map((item) => (
            <div key={item.label} className="rounded-md border p-3 text-sm">
              <div className="mb-1 font-semibold text-gray-700">
                {item.label}
              </div>
              <p className="whitespace-pre-wrap break-words text-gray-800">
                {item.value || "-"}
              </p>
              <Button
                className="mt-2"
                variant="outline"
                size="xs"
                type="button"
                onClick={() => onCopy(item.value, item.label)}
                disabled={!item.value || item.value === "-"}
              >
                {t("eventManage.reminderEmailCopyButton")}
              </Button>
            </div>
          ))}
        </div>
        <div className="flex justify-end pt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t("common.close")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
